import React, { Fragment } from "react";

import {
    setDefaultLanguage,
    setLanguageCookie,
    translate,
} from "react-switch-lang";

setDefaultLanguage("en");
setLanguageCookie();

const Rightbar = (props) => {
    return (
        <Fragment>
            <div className="nav-right col-8 pull-right right-header p-0">
                <ul className="nav-menus">
                    <li className="f-20 font-secondary">
                        <a
                            href="https://infantindia.org/index.html"
                            className="font-secondary"
                        >
                            Home
                        </a>
                    </li>
                    <li className="f-20 font-secondary">
                        <a
                            href="https://infantindia.org/about-us.html"
                            className="font-secondary"
                        >
                            About Us
                        </a>
                    </li>
                    <li className="f-20 font-secondary">
                        <a
                            href="https://infantindia.org/gallery.html"
                            className="font-secondary"
                        >
                            Gallery
                        </a>
                    </li>
                    <li className="f-20 font-secondary">
                        <a
                            href="https://infantindia.org/awards.html"
                            className="font-secondary"
                        >
                            Awards
                        </a>
                    </li>
                    <li className="f-20">
                        <a
                            href="https://infantindia.org/appeal.html"
                            className="font-secondary"
                        >
                            Appeal
                        </a>
                    </li>
                    <li className="f-20 ">
                        <a
                            href="https://infantindia.org/contact.html"
                            className="font-secondary"
                        >
                            Contact
                        </a>
                    </li>
                    <li className="f-20 ">
                        <a
                            href="https://donate.infantindia.org"
                            className="font-primary"
                        >
                            Donate Now
                        </a>
                    </li>
                </ul>
            </div>
        </Fragment>
    );
};
export default translate(Rightbar);
